import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';

// Styles
import './styles.scss';

const BatchingDetailsSkeleton = () => {
  return (
    <Box className="campaignDetailsContainer">
      <Box className="campaignContent">
        {/* Left side - Stepper Skeleton */}
        <Box className="stepperContainer">
          <Typography variant="h6" className="sectionTitle">
            <Skeleton variant="text" width={180} height={28} />
          </Typography>

          <Box className="stepperSkeleton">
            {[1, 2, 3].map((_, index) => (
              <Box key={index} className="stepSkeleton">
                <Box className="stepIconSkeleton">
                  <Skeleton variant="circular" width={46} height={46} />
                </Box>
                <Box className="stepContentSkeleton">
                  <Skeleton variant="text" width={200} height={24} sx={{ mb: 1 }} />
                  <Skeleton variant="text" width={150} height={20} sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width={180} height={20} />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Right side - Table Skeleton */}
        <Box className="tableContainerCampaignOrder">
          <Box className="tableSkeleton">
            <Box className="tableHeaderSkeleton">
              <Box className="headerCellSkeleton">
                <Skeleton variant="text" width={120} height={24} />
              </Box>
              <Box className="headerCellSkeleton">
                <Skeleton variant="text" width={140} height={24} />
              </Box>
              <Box className="headerCellSkeleton">
                <Skeleton variant="text" width={80} height={24} />
              </Box>
            </Box>

            {[1, 2, 3, 4, 5].map((_, index) => (
              <Box key={index} className="tableRowSkeleton">
                <Box className="tableCellSkeleton">
                  <Skeleton variant="text" width={100} height={20} />
                </Box>
                <Box className="tableCellSkeleton">
                  <Skeleton variant="text" width={120} height={20} />
                </Box>
                <Box className="tableCellSkeleton">
                  <Skeleton
                    variant="rectangular"
                    width={110}
                    height={32}
                    sx={{ borderRadius: '16px' }}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BatchingDetailsSkeleton;
